/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Subscription_Start_AbonnementInputs */

const nl_app_subscription_start_abonnement = /** @type {(inputs: App_Subscription_Start_AbonnementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement afsluiten`)
};

/**

* @param {App_Subscription_Start_AbonnementInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const app_subscription_start_abonnement = /** @type {((inputs?: App_Subscription_Start_AbonnementInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Subscription_Start_AbonnementInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_app_subscription_start_abonnement(inputs)
});
export { app_subscription_start_abonnement as "app.subscription.start_abonnement" }